/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Message_Too_ShortInputs */



/**
* | output |
* | --- |
* | "Please enter a message of at least 10 characters" |
*
* @param {Contact_Message_Too_ShortInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_message_too_short = /** @type {((inputs?: Contact_Message_Too_ShortInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Message_Too_ShortInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("请输入至少 10 个字符的留言")
	return /** @type {LocalizedString} */ ("Please enter a message of at least 10 characters")
});